export enum ConfirmationRequestStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
}

export const ConfirmationRequestStatusLabel: Record<
  ConfirmationRequestStatus,
  string
> = {
  [ConfirmationRequestStatus.PENDING]: 'Payment pending',
  [ConfirmationRequestStatus.COMPLETED]: 'Payment received',
  [ConfirmationRequestStatus.CANCELLED]: 'Canceled',
  [ConfirmationRequestStatus.REFUNDED]: 'Refunded',
}

export function getConfirmationRequestStatusLabel(
  status?: ConfirmationRequestStatus | string | null
): string {
  if (!status) return ''
  return (
    ConfirmationRequestStatusLabel[status as ConfirmationRequestStatus] ?? ''
  )
}

export const ConfirmationRequestErrorMessages = {
  ADMISSION_GROUP_IS_REQUIRED: 'admissionGroup is required',
  ADMISSION_GROUP_TYPE_IS_REQUIRED: 'admissionGroupType is required',
  ADMISSION_GROUP_TYPE_IS_INVALID: 'admissionGroupType is invalid',
  VENUE_IS_REQUIRED: 'venue is required',
  STATUS_IS_REQUIRED: 'status is required',
  STATUS_INVALID: 'status is invalid',
  NAME_IS_REQUIRED: 'name is required',
  DATE_IS_REQUIRED: 'date is required',
  GUESTS_IS_REQUIRED: 'guests is required',
  ARRIVAL_TIME_MUST_BE_A_DATE: 'arrivalTime must be a date',
  PAYMENT_AMOUNT_TYPE_REQUIRED: 'paymentAmountType is required',
  PAYMENT_AMOUNT_TYPE_INVALID: 'paymentAmountType is invalid',
  PAYMENT_AMOUNT_INVALID: 'paymentAmount is invalid',
  QUANTITY_IS_INVALID: 'quantity is invalid',
  QUANTITY_CANNOT_BE_GREATER_THAN_1: 'quantity cannot be greater than 1',
  INVALID_PAYMENT_AMOUNT_TYPE_FOR_RESERVATION_ONLY:
    'venue is reservation only, cannot create payment link for full or deposit payments',
  ALREADY_COMPLETED: 'This payment request has already been completed',
  ALREADY_CANCELLED: 'This payment request has already been cancelled',
  ALREADY_REFUNDED: 'This payment request has already been refunded',
} as const
